import { Store } from '@ngrx/store';
import { inject, Injectable, Signal } from '@angular/core';
import { USER_DOWNLOAD_ACTIONS, USER_EXPORT_ACTIONS } from '../actions';
import {
  DownloadRequest,
  ExportRequest,
  DocumentDownloadParams,
  DocumentDownloadResponse,
  DocumentExportResponse,
} from '../types';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

import {
  DOWNLOADS_FEATURE_STATE,
  EXPORTS_FEATURE_STATE,
} from '../feature-state';

@Injectable({
  providedIn: 'root',
})
export class DownloadsExportFacadeService {
  private readonly _store = inject(Store);

  $downloadStoreData = toSignal(
    this._store.select(DOWNLOADS_FEATURE_STATE.selectDownloadsData).pipe(
      filter(Boolean),
      map((d) => {
        return {
          data: d.data,
          total: d.total,
        };
      }),
    ),
  ) as Signal<Pick<DocumentDownloadResponse, 'data' | 'total'>>;

  initiateDownload(downloadRequest: DownloadRequest, data: unknown): void {
    this._store.dispatch(
      USER_DOWNLOAD_ACTIONS.initiateDownload({
        data,
        downloadRequest,
      }),
    );
  }

  getDocumentLink(documentId: string) {
    this._store.dispatch(
      USER_DOWNLOAD_ACTIONS.getDocumentLink({
        documentId,
      }),
    );
  }

  loadDownloadDocuments(params: DocumentDownloadParams) {
    this._store.dispatch(
      USER_DOWNLOAD_ACTIONS.loadDocumentDownloads({ params }),
    );
  }

  $exportStoreData = toSignal(
    this._store.select(EXPORTS_FEATURE_STATE.selectExportsData).pipe(
      filter(Boolean),
      map((d) => ({ data: d.data, total: d.total })),
    ),
  ) as Signal<Pick<DocumentExportResponse, 'data' | 'total'>>;

  initiateExport(exportRequest: ExportRequest, data: unknown): void {
    this._store.dispatch(
      USER_EXPORT_ACTIONS.initiateExport({
        data,
        exportRequest,
      }),
    );
  }
  loadExportDocuments(params: DocumentDownloadParams) {
    this._store.dispatch(USER_EXPORT_ACTIONS.loadDocumentExports({ params }));
  }
}
